module.exports = __webpack_public_path__ + "img/about-banner-无logo.66509290.jpg";